const initialState = {
    isReadingInvoices: false,
    entries: [],
    count: 0
}

export default initialState;
